module.exports = __webpack_public_path__ + "static/media/Notifications.1b023e2d.png";